import {
  GET_VCARD_START,
  GET_VCARD_END,
  SET_VCARD,
  CLEAR_VCARD,
} from "./types";
import vCardServices from "../../services/vCard.services";

export const getQrProfile = (qrId) => (dispatch) => {
  dispatch({
    type: GET_VCARD_START,
  });
  return vCardServices
    .getQrProfile(qrId)
    .then(({ data }) => {
      dispatch({
        type: SET_VCARD,
        payload: { ...data, message: "success" },
      });
      dispatch({
        type: GET_VCARD_END,
      });
    })
    .catch((err) => {
      const message = err.response?.data?.data;
      const status = err.response?.data?.status;

      dispatch({
        type: SET_VCARD,
        payload: {
          status,
          message,
          vCard: {},
        },
      });
      dispatch({
        type: GET_VCARD_END,
      });
    });
};

export const clearQrProfile = () => (dispatch) => ({
  type: CLEAR_VCARD,
});
